import { type PropsWithChildren } from 'react';

import type { NumericalThresholdConfig } from '../../core/types/thresholds.js';

/**
 * @public
 */
export type HistogramThresholdProps = NumericalThresholdConfig;

/**
 * @public
 */
export const Threshold = (props: PropsWithChildren<HistogramThresholdProps>) =>
  null;
